<template>
  <section class="container">
  <scroll
    :data="dataList"
    :allLoaded="allLoaded"
    @pulldown="loadData"
    @loadUp="loadup"
    v-if="dataList.length"
    :showBottomTips="false"
    >
    <section class="dataList">
      <section class="list_item" @click="toDetail(item.id)" v-for="item in dataList" :key="item.id">
        <img :src="item.imgUrl">
        <p class="title">{{item.name}}</p>
        <p :class="['lable',item.serviceType==0?'':'more_time']">{{item.serviceType | serviceType}}</p>
        <span>¥{{item.price | priceFormat}}</span>
      </section>
    </section>
  </scroll>
   <no-message v-if="!dataList.length && loaded"></no-message>
  </section>
</template>

<script>
import util from "../../utils/util";
import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
import { mapState } from "vuex";
import {getOfficeMaterialListByMarketId } from "../../utils/api.js";
export default {
  name: "officeService",
  components:{
    Scroll,
    NoMessage
  },
  data() {
    return {
      dataList:[],
      allLoaded:true,
      loaded:false
    }
  },
  filters:{
    serviceType(val){
      if(val == '0'){
        return '一次性送货'
      }else{
        return '多次送货服务'
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    if(this.$route.query.pageTitle){
      console.log('in pageTitle')
      document.title =this.$route.query.pageTitle
      this.$route.meta.title =this.$route.query.pageTitle
    }
    this.getOfficeMaterialListByMarketId()
  },
  methods: {
    loadData(){
      this.getOfficeMaterialListByMarketId()
    },
    loadup(){},
    getOfficeMaterialListByMarketId(){
      util.showLoading()
      getOfficeMaterialListByMarketId({}).then(res=>{
        console.log(res)
        util.hideLoading()
        if(res.res.code === 10000 && res.body){
          this.dataList = res.body.tbOfficeMaterials || [];
          if(this.dataList.length > 0){
            this.dataList = this.dataList.sort(util.compare("sortOrder"));
          }
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    toDetail(id){
      this.$router.push({
        path:`/officeServiceDetail?id=${id}`
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  background:#eee;
  height:100vh;
}
.dataList{
  .flex();
  flex-wrap: wrap;
  margin-top:20px;
  .list_item{
    width:344px;
    margin:0 0 20px 20px;
    background:#fff;
    border-radius: 8px;
    overflow: hidden;
    img{
      display: block;
      width:344px;
      height:258px;
      margin-bottom:20px;
      background:#f4f4f4;
    }
    .title{
      .textOver(100%);
      padding:0 20px;
      font-size:24px;
      color:rgba(51,51,51,1);
      line-height:40px;
      margin-bottom:10px;
    }
    .lable{
      padding:0 6px;
      height:36px;
      line-height: 36px;
      font-size:24px;
      border-radius: 4px;
      display: inline-block;
      margin-left:20px;
      margin-bottom:10px;
      background:rgba(255,240,225,1);
      color:#FF7E1E;
    }
    .more_time{
      background:#def5ed;
      color:#16bc84;
    }
    .one_time{
      background:#FFF0E1;
      color:#FF7E1E;
    }
    span{
      display: block;
      font-size:28px;
      color:rgba(252,63,86,1);
      line-height:40px;
      padding-left:20px;
      margin-bottom: 20px;
    }
  }
}
</style>